import {useEffect, useRef} from 'react';
import {captureSentryException} from 'app/services/sentry/sentryLogging';
import {useNative} from 'app/contexts/NativeContext';
import {useDispatch} from 'react-redux';

const useInitFirebase = () => {
  const dispatch = useDispatch();
  const nativeInfo = useNative();
  const isInitialized = useRef(false);

  useEffect(() => {
    if (isInitialized.current) {
      return;
    }
    const initializeFirebase = async () => {
      isInitialized.current = true;
      const {initFirebase} = await import('app/services/firebase');
      initFirebase(dispatch, nativeInfo);
    };

    // call the function
    initializeFirebase().catch(e =>
      captureSentryException(e, {extra: {errorLocation: 'Initializing Firebase in AppShell'}})
    );
  }, [dispatch, nativeInfo]);
};

export default useInitFirebase;
